import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Terminal Type URL=========================
export const Package_GetList_ByPartnerID = `${BASE_API_URL}/Package/PartnerAfterFiveDays_ExpirePackage_GetList`
export const Partner_ExpirePackage_GetList = `${BASE_API_URL}/Package/Partner_ExpirePackage_GetList`

export function GetPartnerAfterFiveDays_ExpirePackage_GetListAPI() {
  return axios.get(Package_GetList_ByPartnerID)
}

export function GetPartner_ExpirePackage_GetListAPI() {
  return axios.get(Partner_ExpirePackage_GetList)
}
